<template>


    <section> 
          <b-container>
            <b-row align-v="center" class="row-grid">
              <b-col md="6" class="order-md-2">
                <b-img src="img/custom/lieber.png" fluid />
              </b-col>
              <b-col md="6" class="order-md-1">
                <div class="pr-md-5">
                  

                        <h1>
                            Are you planning to include text in your book ?
                        </h1>
                        <b-form-radio-group v-model="currentSnapWizard.text_content">
                        <div>
                            <b-form-radio value="1" name="unchecked" class="mb-3">
                                Yes
                            </b-form-radio>
                        </div>
                        <div>
                            <b-form-radio value="0" name="checked" class="mb-3">
                                No
                            </b-form-radio>
                        </div>
                    </b-form-radio-group>



                </div>
              </b-col>
            </b-row>
          </b-container>
        </section>
    
    
    
    
    
    
    
    </template>
    
    
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'

export default {
    name: 'snap07',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip
    },
    methods: {
        onCancel: function () { },
        onProceed: function () { },
        allDataValidated: function () {
                /*
                console.log(this.currentPhotoBook.title);
                console.log(this.currentPhotoBook.subtitle);
                console.log(this.currentPhotoBook.blurb);
                console.log(this.currentPhotoBook.bio);
                console.log(this.currentPhotoBook.orientation);
                console.log(this.currentPhotoBook.keywords);
                */
            if (
                this.currentSnapWizard.text_content == 1 || this.currentSnapWizard.text_content == 0
            ) {
                //this.claim.allValidated = true;
                console.log("VALID ENABLING NEXT");
                this.$emit('allowProceed');
                this.$emit('showFooterNav');
                return true;
            }
            this.$emit('denyProceed');
            this.$emit('hideFooterNav');
            return false;
        },
    },
    computed: {
        ...mapGetters({
            currentSettings: 'currentSettings',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
        }),
    },
    watch: {
        currentSnapWizard: {
            handler:function (newItem) {
                //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.split(',');
                this.allDataValidated();
            },
            deep: true
        },
    },
    mounted() {
        this.$emit('denyProceed');
        this.allDataValidated();
    }
};
</script>